import { LuxButton, LuxTypography, VisionXIconWhite } from '@gemini/fe-ds-core';
import { FooterCtaDTO } from '@utils/interfaces';

import { FooterWrapper, LinksWrapper } from './PageFooter.styles';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

export interface FooterProps {
  externalLinks: FooterCtaDTO[];
  isForTypWidget?: boolean;
  textColor?: string;
  showLogo?: boolean;
}

const PageFooter = ({
  externalLinks,
  isForTypWidget = false,
  textColor = 'white!important',
  showLogo = false,
}: FooterProps) => {
  const colorConfig = useOnlineBookingStore(
    state => state.generalConfig?.customization,
  );
  return (
    <FooterWrapper
      isForTypWidget={isForTypWidget}
      color={colorConfig?.secondaryColor}
      showLogo={showLogo}
      className="ob-no-print"
    >
      {showLogo && <VisionXIconWhite />}
      <LinksWrapper>
        {externalLinks &&
          externalLinks.map((link, index) => (
            <LuxButton
              key={index}
              variant="link"
              size="small"
              style={{ color: textColor }}
              onClick={() => !isForTypWidget && window.open(link.url)}
              // key={link.label}
            >
              <LuxTypography color={textColor}> {link.label}</LuxTypography>
            </LuxButton>
          ))}
      </LinksWrapper>
    </FooterWrapper>
  );
};

export default PageFooter;
